import DateTimeService from './DateTimeService';

type EntityWithPeriod = {
    dateFrom: Date;
    dateTo?: Date;
    dateSince?: Date;
};

export default class InlineDateValidationService {

    public static validateFromDate = (row: EntityWithPeriod) => {
        const isValid = InlineDateValidationService.validateDate(row);
        if (!row.dateSince && row.dateFrom && isValid) {
            row.dateSince = new Date(row.dateFrom);
        }
        return isValid;
    };

    public static validateDate = (row: EntityWithPeriod): boolean => {
        if (!row.dateTo) return true;

        const maxDate = DateTimeService.addYears(DateTimeService.now(), 50);
        if (DateTimeService.isAfterDate(row.dateTo, maxDate)) return false;
        if (row.dateFrom) return DateTimeService.isBeforeDate(row.dateFrom, row.dateTo);
        
        return true;
    };

	public static validateInactivationDate = (row: EntityWithPeriod, minDate?: Date, maxDate?: Date ): boolean => {        
        if(!row.dateFrom) return false;
		
		if(row.dateTo && maxDate){
			const isBefore =  DateTimeService.isBeforeDate(row.dateTo, maxDate) || DateTimeService.isSameDate(row.dateTo, maxDate);
			if(!isBefore) return false;
		}

		if(minDate){
			const isBeforeOrSameDate =  DateTimeService.isBeforeDate(minDate, row.dateFrom) || DateTimeService.isSameDate(minDate, row.dateFrom);
			if(!isBeforeOrSameDate) return false;
		}

        if (row.dateTo) return DateTimeService.isBeforeDate(row.dateFrom, row.dateTo);
        return true;
	};
}